// removed by extract-text-webpack-plugin
module.exports = {"article":"src-components-pages-Testimonials----Testimonials-module---article---19BFH","quote":"src-components-pages-Testimonials----Testimonials-module---quote---3yAlP","quoteName":"src-components-pages-Testimonials----Testimonials-module---quoteName---2BKc7","quoteAddress":"src-components-pages-Testimonials----Testimonials-module---quoteAddress---3iGoP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Testimonials/Testimonials.module.sass
// module id = 425
// module chunks = 208176855801404